import { OrderAdjustmentsTypes } from 'constants/orderAdjustmentTypes';

import { useGetOrderAdjustments } from 'pages/Orders/hooks/useGetOrderAdjustments';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useShowController } from 'react-admin';
import { LinearProgress } from 'shared/mui/LinearProgress/LinearProgress';
import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { Order } from 'types/embedded/order';

export const OrdersShowCommonInfoStateAdjustmentsField = (): JSX.Element => {
  const translate = useTypedTranslate();

  const { record: order } = useShowController<Order>();

  const { data: orderAdjustments, isFetching } = useGetOrderAdjustments(order?.originId);
  const orderAdjustmentsOrderAmount = orderAdjustments?.filter(
    (adjustment) => adjustment.adjustmentType.value === OrderAdjustmentsTypes.OrderAmount,
  );

  if (isFetching) {
    return <LinearProgress />;
  }

  const lastAdjustment = orderAdjustmentsOrderAmount?.at(-1);
  if (!lastAdjustment) {
    return <Typography variant="body2">{translate('app.common.no')}</Typography>;
  }

  return (
    <Stack alignItems="center" direction="row" gap="8px">
      <Typography sx={{ textDecoration: 'line-through', color: 'text.secondary' }} variant="body2">
        {lastAdjustment.oldAmount}
      </Typography>
      &rarr;
      <Typography variant="body2">{lastAdjustment.newAmount}</Typography>
    </Stack>
  );
};
